// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3qGLY","input":"style_input__3AF0r","privacy":"style_privacy__CxCYR","privacyText":"style_privacyText__d3f61"};